<template>
  <div>
    <loadingCube v-if="!cis_loaded" :loadingMessage="'CIS TAX STATUS'"></loadingCube>
    <div class="row" v-if="notEmptyObject(hmrc_cis_status)">
      <div class="col-xl-4">
        <div class="tax_status" v-if="notEmptyObject(cis_status) && cis_status.cis_response !== null">
          <div class="ts_header">Tax Status</div>
          <div class="ts_body">
            <div v-if="cis_status.cis_response.status === 'unmatched'" class="unmatched">
              <div class="match">Unmatched</div>
              <div class="perc">
                <span>30%</span>
              </div>
            </div>
            <div v-if="cis_status.cis_response.status === 'matched'" class="matched">
              <div class="match">Matched</div>
              <div class="perc">
                <span v-if="cis_status.cis_response.tax_treatment === 'net'">20%</span>
                <span v-else-if="cis_status.cis_response.tax_treatment === 'gross'">0%</span>
              </div>
            </div>
          </div>
          <div class="ts_footer">
            <div class="v_num">
              <h5 class="mb-0">Verification Number</h5>
              <span>{{ cis_status.cis_response.verification_number }}</span>
            </div>
            <div class="v_date">
              <h5 class="mb-0">Latest Verification Date</h5>
              <span class="mb-2 d-block" v-if="cis_status.date_last_verified !== null ">{{ cis_status.date_last_verified | formatDateTime }}</span>
              <span class="mb-2 d-block" v-else>&nbsp;</span>
            </div>
            <div class="v_date">
              <h5 class="mb-0">Latest Verification By</h5>
              <span class="mb-2 d-block" v-if="cis_status.verified_by_id !== null ">{{ cis_status.verified_by.first_name }} {{ cis_status.verified_by.surname }}</span>
              <span class="mb-2 d-block" v-else>&nbsp;</span>
            </div>
            <div class="v_date">
              <h5 class="mb-0">First Verification Date</h5>
              <span v-if="cis_status.date_first_verified !== null ">{{ cis_status.date_first_verified  | formatDateTime }}</span>
              <span class="mb-2 d-block" v-else>&nbsp;</span>
            </div>
          </div>
        </div>
        <div class="tax_status" v-else>
          <div class="ts_header">Tax Status</div>
          <div class="ts_body">
            <div class="unmatched">
              <div class="match">NOT VERIFIED</div>
              <div><i class="fas fa-times"></i></div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xl-8">
        <div class="row">
          <!-- Worker Information -->
          <div class="col-12">
            <b-card header="CIS VERIFICATION" header-tag="h4" body-class="mb-3 record_card_body">
              <div class="row">
                <div class="col-12">
                  <h5>CURRENT COMPANY INFORMATION</h5>
                </div>
                <!-- Company Name -->
                <div class="col-12 form-group">
                  <label class="form-label" for="w_company_name">Trading Name</label>
                  <p id="w_company_name">
                    <span v-if="company.company_name !== null">{{ company.company_name }}</span>
                    <span v-else>&nbsp;</span>
                  </p>
                </div>
                <!-- Company UTR Number -->
                <div class="col-lg-6 form-group">
                  <label class="form-label" for="company_utr_number">Ltd Company UTR Number</label>
                  <p id="company_utr_number">
                    <span v-if="company.rel_profile.utr_number !== null">{{ company.rel_profile.utr_number }}</span>
                    <span v-else>&nbsp;</span>
                  </p>
                </div>
                <!-- Limited Company LTD Number -->
                <div class="col-lg-6 form-group">
                  <label class="form-label" for="company_ltd_reg_number">LTD Registration Number</label>
                  <p id="company_ltd_reg_number">
                    <span v-if="company.rel_profile.ltd_reg_number !== null">{{ company.rel_profile.ltd_reg_number }}</span>
                    <span v-else>&nbsp;</span>
                  </p>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <hr class="mt-0">
                </div>
              </div>
              <ValidationObserver ref="verifyCompanyCIS" slim>
                <form role="form" @submit.prevent="verify_company_cis">
                  <div class="row">
                    <div class="col-12">
                      <h5>VERIFICATION INFORMATION</h5>
                    </div>
                    <!-- Trading Name -->
                    <ValidationProvider rules="required" v-slot="{errors, classes}" name="Trading Name" tag="div" class="form-group col-12">
                      <label class="form-label" for="trading_name">Trading Name</label>
                      <input type="search" v-model="hmrc_cis_status.trading_name" id="trading_name" name="trading_name" class="form-input requiredField" :class="classes">
                      <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                    </ValidationProvider>
                    <!-- UTR Number -->
                    <ValidationProvider rules="required|digits:10" v-slot="{errors, classes}" name="UTR Number" tag="div" class="col-xl-6 form-group">
                      <label class="form-label" for="utr_number">UTR Number</label>
                      <input type="search" v-model="hmrc_cis_status.utr_number" id="utr_number" name="utr_number" class="form-input requiredField" :class="classes" maxlength="10">
                      <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                    </ValidationProvider>
                    <!-- Limited Company LTD Number -->
                    <ValidationProvider rules="required|ltdCompNoValidate" v-slot="{errors, classes}" name="LTD Reg Number" tag="div" class="form-group col-xl-6">
                      <label class="form-label" for="crn">LTD Registration Number (CRN)</label>
                      <input type="search" v-model="hmrc_cis_status.crn" id="crn" name="crn" class="form-input requiredField" :class="classes">
                      <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                    </ValidationProvider>

                    <div class="col-lg-6 offset-lg-6">
                      <button type="submit" class="btn orcaBtn w-100 mt-0 sm_btn" :disabled="progress">
                        <span v-if="progress" class="btnLoading"><i class="fas fa-spinner fa-pulse"></i>Verifying with HMRC ...</span>
                        <span v-else>HMRC Verification</span>
                      </button>
                    </div>
                  </div>
                  <div class="row" v-if="progress">
                    <div class="col-12 mt-4">
                      <div class="progress">
                        <div class="progress-bar" role="progressbar" :style="'width: ' + cis_progress + '%'" :aria-valuenow="cis_progress"
                             aria-valuemin="0" :aria-valuemax="100"></div>
                      </div>
                    </div>
                  </div>
                </form>
              </ValidationObserver>
            </b-card>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import loadingCube from "loaders/record_loader";

export default {
  name: "company_cis_verification",
  components: {
    loadingCube,
    Multiselect
  },
  props: ['company', 'cis_status', 'cis_loaded'],
  data() {
    return {
      progress: false,
      xmlState: 'initial',
      cis_progress: 0,
      hmrc_cis_status: {},
      ms_opts: {
        employment_types: this.$store.state.crm_options.worker_employment_type.filter(et => et.id === 32 || et.id === 29),
        tax_rates: ['Higher Rate (30%)', 'Standard Rate (20%)', 'Gross (0%)']
      },
      override: {
        tax_rate: null,
        verification_number: ''
      }
    }
  },
  beforeMount() {
    this.hmrc_cis_status = this.cis_status
  },
  methods: {
    verify_company_cis() {
      this.$refs.verifyCompanyCIS.validate().then(success => {
        if (!success) {
          this.formErrorsValidationScroll(this.$refs.verifyCompanyCIS);
        }
        else {
          // SET LIMITED COMPANY TYPE
          this.hmrc_cis_status.employment_type_id = 32;
          //
          this.progress = true;
          this.xmlState = 'validate';
          this.cis_progress = 33.33;
          // First Step Verification -> create request xml file
          axios.post(this.crmApiPath + 'hmrc/cis/verification/company/generate_xml_file', {
            company_id: this.company.id,
            details: this.hmrc_cis_status
          }).then(acknowledge => {
            if (acknowledge.data.status === 200) {
              this.$snotify.warning(acknowledge.data.message);
              this.xmlState = 'verify';
              this.cis_progress = 50;
              setTimeout(() => {
                axios.post(this.crmApiPath + 'hmrc/cis/verification/company/generate_xml_poll', {
                  company_id: this.company.id,
                  correlationID: acknowledge.data.data
                }).then(verified => {
                  if (verified.data.status === 200) {
                    this.cis_progress = 66.66;
                    // update first verified date if null
                    if (this.hmrc_cis_status.date_first_verified === null) {
                      this.hmrc_cis_status.date_first_verified = this.$moment.utc().format('YYYY-MM-DD HH:mm:ss');
                    }
                    else {
                      this.hmrc_cis_status.date_first_verified = this.$moment.utc(this.hmrc_cis_status.date_first_verified).format('YYYY-MM-DD HH:mm:ss');
                    }
                    // update last verified date
                    this.hmrc_cis_status.verified_by_id = this.$store.state.auth.me.id;
                    this.hmrc_cis_status.date_last_verified = this.$moment.utc().format('YYYY-MM-DD HH:mm:ss');
                    axios.patch(this.crmApiPath + 'hmrc/cis/verification/company/update_cis_info/' + this.hmrc_cis_status.id, this.hmrc_cis_status).then(() => {
                      this.cis_progress = 100;
                      setTimeout(() => {
                        this.$bus.$emit('company_cis_tax_status::reload', {action: true});
                        this.$snotify.success(verified.data.message);
                        this.progress = false;
                        this.xmlState = 'initial';
                      }, 500);
                    })
                  }
                  else {
                    this.$snotify.error(verified.data.message);
                    this.cis_progress = 0;
                    this.progress = false;
                  }
                });
              }, 10000);
            }
            else {
              this.$snotify.error(acknowledge.data.message);
              this.cis_progress = 0;
              this.progress = false;
            }
          });
        }
      });
    }
  }
}
</script>

<style scoped lang="scss">
.tax_status {
  display:       block;
  border:        5px solid $bc_2;
  border-radius: $border_radius_2;
  margin-bottom: 20px;

  .ts_header {
    border-bottom:  5px solid $bc_2;
    text-align:     center;
    font-size:      1.75rem;
    font-weight:    bold;
    text-transform: uppercase;
  }

  .ts_body {
    .unmatched, .matched {
      font-size:      1.5rem;
      text-transform: uppercase;
      font-weight:    bold;
      text-align:     center;
    }

    .unmatched {
      color:      $white;
      background: $red;

      i {
        font-size: 3rem;
      }
    }

    .matched {
      color:      $white;
      background: $green;

      .perc {
        font-size: 2rem;
      }
    }
  }

  .ts_footer {
    padding:    10px;
    border-top: 5px solid $bc_2;
    text-align: center;

    .v_num {
      margin-bottom: 10px;

      h5 {
        font-size: 0.75rem;
      }
    }

    .v_date {
      h5 {
        font-size: 0.75rem;
      }
    }
  }
}
.progress-bar {
  background-color: $bc_1;
}
</style>
